








































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import InjectionAuditService from "@/services/InjectionAuditService";
import moment from "moment";
import SignCard from "./SignCard.vue";

@Component({ components: { SignCard } })
export default class InjectionAuditDetail extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;
  loading = true;
  tab = 0;

  signDialog = false;
  signRole: "auditor" | "ka_unit" | "ka_ppi" | "pimpinan" = "auditor";
  signPassword = "";
  overrideReason = "";
  signing = false;

  rtlDialog = false;
  rtlForm: any = {};
  savingRtl = false;

  aeDialog = false;
  aeForm: any = {};
  savingAe = false;

  tipeKejadianOptions = [
    { text: "Needle Stick Injury", value: "needle_stick_injury" },
    { text: "Splash Mukosa", value: "splash_mukosa" },
    { text: "Luka Benda Tajam Lain", value: "sharp_injury_lain" },
    { text: "Medication Error", value: "medication_error" },
    { text: "Reaksi Obat/KTD", value: "reaksi_obat" },
    { text: "Lainnya", value: "lainnya" }
  ];

  severityOptions = [
    { text: "Ringan", value: "ringan" },
    { text: "Sedang", value: "sedang" },
    { text: "Berat", value: "berat" },
    { text: "Sangat Berat / Sentinel", value: "sangat_berat" }
  ];

  async created() {
    await this.loadSession();
    this.loading = false;
  }

  async loadSession() {
    const res = await InjectionAuditService.find(this.sessionId);
    this.session = res.data.data;
  }

  get itemsOptions() {
    if (!this.session || !this.session.item_checks) return [];
    return this.session.item_checks
      .filter((c: any) => c.item_definition)
      .map((c: any) => ({
        id: c.item_definition.id,
        label: `#${c.item_definition.nomor_urut}. ${c.item_definition.item_penilaian.substring(0, 80)}...`
      }));
  }

  get canSubmitAuditor() {
    if (!this.session) return false;
    if (this.session.signed_auditor_at) return false;
    const filled = (this.session.item_checks || []).filter((c: any) => c.hasil).length;
    return filled > 0;
  }

  get auditorReason() {
    if (!this.session) return "";
    if (this.session.signed_auditor_at) return "Sudah ditandatangani";
    const filled = (this.session.item_checks || []).filter((c: any) => c.hasil).length;
    if (filled === 0) return "Minimal 1 item checklist harus terisi";
    return "";
  }

  get needOverrideReason() {
    return this.session && this.session.jumlah_petugas_diobservasi < 5;
  }

  get kategoriBg() {
    if (!this.session || !this.session.kategori_kepatuhan) return "";
    return {
      baik: "green lighten-5",
      intermediate: "orange lighten-5",
      minimal: "red lighten-5"
    }[this.session.kategori_kepatuhan] || "";
  }

  get signRoleLabel() {
    return {
      auditor: "Auditor PPI",
      ka_unit: "Kepala Unit / Ruangan",
      ka_ppi: "Ketua Tim PPI / IPCO",
      pimpinan: "Pimpinan Fasyankes"
    }[this.signRole];
  }

  promptSign(role: string) {
    this.signRole = role as any;
    this.signPassword = "";
    this.overrideReason = "";
    this.signDialog = true;
  }

  async confirmSign() {
    if (!this.signPassword) return;
    this.signing = true;
    try {
      const payload: any = { password: this.signPassword };
      if (this.signRole === "auditor" && this.needOverrideReason) {
        payload.override_min_observasi_reason = this.overrideReason || "Override oleh auditor";
      }
      if (this.signRole === "auditor") await InjectionAuditService.submitAuditor(this.sessionId, payload);
      else if (this.signRole === "ka_unit") await InjectionAuditService.approveKaUnit(this.sessionId, payload);
      else if (this.signRole === "ka_ppi") await InjectionAuditService.approveKaPpi(this.sessionId, payload);
      else if (this.signRole === "pimpinan") await InjectionAuditService.approvePimpinan(this.sessionId, payload);
      this.signDialog = false;
      await this.loadSession();
    } catch (e) {
      // handled
    }
    this.signing = false;
  }

  openRtlForm(r?: any) {
    this.rtlForm = r ? { ...r } : {
      item_definition_id: null,
      temuan_text: "",
      akar_masalah: "",
      tindak_lanjut: "",
      pic_user_id: null,
      target_selesai: moment().add(30, "days").format("YYYY-MM-DD"),
      status_verifikasi: "open",
      tanggal_selesai: "",
      bukti_penyelesaian: ""
    };
    this.rtlDialog = true;
  }

  async saveRtl() {
    this.savingRtl = true;
    try {
      if (this.rtlForm.id) {
        await InjectionAuditService.updateRtl(this.sessionId, this.rtlForm.id, this.rtlForm);
      } else {
        await InjectionAuditService.storeRtl(this.sessionId, this.rtlForm);
      }
      this.rtlDialog = false;
      await this.loadSession();
    } catch (e) {
      // handled
    }
    this.savingRtl = false;
  }

  async deleteRtl(r: any) {
    if (!confirm("Hapus RTL ini?")) return;
    await InjectionAuditService.destroyRtl(this.sessionId, r.id);
    await this.loadSession();
  }

  async autoGenRtl() {
    await InjectionAuditService.autoGenerateRtl(this.sessionId);
    await this.loadSession();
  }

  openAeForm(ae?: any) {
    this.aeForm = ae ? { ...ae } : {
      tipe_kejadian: "needle_stick_injury",
      waktu_kejadian: moment().format("YYYY-MM-DDTHH:mm"),
      lokasi_kejadian: "",
      deskripsi: "",
      severity: "sedang",
      tindakan_pertolongan_pertama: "",
      dilaporkan_k3rs: false,
      tanggal_pelaporan_k3rs: "",
      nomor_laporan_k3rs: "",
      petugas_terdampak_profesi: ""
    };
    this.aeDialog = true;
  }

  async saveAe() {
    this.savingAe = true;
    try {
      if (this.aeForm.id) {
        await InjectionAuditService.updateAdverseEvent(this.sessionId, this.aeForm.id, this.aeForm);
      } else {
        await InjectionAuditService.storeAdverseEvent(this.sessionId, this.aeForm);
      }
      this.aeDialog = false;
      await this.loadSession();
    } catch (e) {
      // handled
    }
    this.savingAe = false;
  }

  async deleteAe(ae: any) {
    if (!confirm("Hapus kejadian ini?")) return;
    await InjectionAuditService.destroyAdverseEvent(this.sessionId, ae.id);
    await this.loadSession();
  }

  printPdf() {
    InjectionAuditService.printPdf(this.sessionId);
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }
  formatDateTime(d: string) {
    return d ? moment(d).format("DD-MM-YYYY HH:mm") : "-";
  }

  rtlStatusColor(s: string) {
    return { open: "grey", in_progress: "blue", closed: "green", overdue: "red" }[s] || "grey";
  }

  severityColor(s: string) {
    return { ringan: "blue", sedang: "orange", berat: "red", sangat_berat: "red darken-4" }[s] || "grey";
  }
}
